import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ValetServiceApprovalList from "./List";
import {getValetItemLineApprovalList} from "../../../../../services/redux/sales/postSales/action";

const mapStateToProps = (state) => ({
    lineItemsApprovalList: state.postSalesReducer.lineItemsApprovalList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getValetItemLineApprovalList
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ValetServiceApprovalList);
